import { refetchActiveRoutePageQueries } from "@/utils/routeRefresh";
import { useApolloClient } from "@apollo/client/react";
import { useCallback } from "react";

/** Refetches the current route's active page queries via Apollo. */
export function useRouteRefresh(): () => void {
  const client = useApolloClient();

  return useCallback(() => {
    refetchActiveRoutePageQueries(client);
  }, [client]);
}
